import React, { useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import styled from "styled-components";
import { IngresoPorMascota } from "../../../services/analisisFinanzas";
import { useEstadisticasNumericas } from "../../../hooks/estadisticasNumericas";
import { currencyFormat } from "../../../utils/numberUtils";
import EstadisticasBadges from "../../organisms/EstadisticasBadges";
import Pagination from "../../organisms/Pagination";
import { generatePage } from "../../../utils/tableUtils";

interface IngresosPorMascotaTableProps {
  ingresosPorMascota: IngresoPorMascota[];
  isLoading: boolean;
  itemsPorPagina: number;
}

function IngresosPorMascotaTable({
  ingresosPorMascota,
  isLoading,
  itemsPorPagina,
}: IngresosPorMascotaTableProps) {
  const [activePageNumber, setActivePageNumber] = useState(1);
  const estadisticas = useEstadisticasNumericas(
    ingresosPorMascota,
    (item) => item.ingresos
  );

  const paginaActual = useMemo(
    () =>
      generatePage(ingresosPorMascota, activePageNumber, itemsPorPagina) as IngresoPorMascota[],
    [ingresosPorMascota, activePageNumber, itemsPorPagina]
  );

  return (
    <>
      <EstadisticasBadges
        estadisticas={estadisticas}
        formatearValor={currencyFormat}
      />

      <Table responsive hover>
        <thead>
          <tr>
            <StyledColHeader>Mascota</StyledColHeader>
            <StyledColHeader>Propietario</StyledColHeader>
            <StyledColHeader>Ingresos</StyledColHeader>
          </tr>
        </thead>
        <tbody>
          {paginaActual.map((item) => (
            <tr key={item.idMascota}>
              <td>{item.nombre}</td>
              <td>{item.propietario}</td>
              <td>{currencyFormat(item.ingresos)}</td>
            </tr>
          ))}
          {estadisticas && (
            <StyledSummaryRow>
              <td colSpan={2}>Total</td>
              <td>{currencyFormat(estadisticas.total)}</td>
            </StyledSummaryRow>
          )}
          {!isLoading && paginaActual.length === 0 && (
            <tr>
              <td colSpan={3}>
                No hay ingresos por mascota para el rango de fechas seleccionado.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Pagination
        pageSize={itemsPorPagina}
        setActivePageNumber={setActivePageNumber}
        activePageNumber={activePageNumber}
        rows={ingresosPorMascota}
      />
    </>
  );
}

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledSummaryRow = styled("tr")`
  background-color: ${(props) => props.theme.colors.light};
  font-weight: 700;
`;

export default IngresosPorMascotaTable;
